<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import DurationInput from '@/components/input/DurationInput.vue'
import Loading from '@/components/Loading.vue'
import validationFormMixin from '@/mixins/validation.mixin'
import http from '@/utils/http'
import { formatDate } from '@/utils/transform'
import { validaData } from '@/utils/validations/date'

export default {
  name: 'SensorVirtualPeriodoTurno',
  components: { DurationInput, Loading },
  mixins: [validationMixin, validationFormMixin],
  props: {
    data: {
      type: Object,
      required: false,
    },
    localId: {
      type: String,
      required: true,
    },
    onlyForm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  validations: {
    form: {
      horarioInicio: { required, dayTime: validaData },
      duracao: { required },
    },
  },
  data() {
    return {
      form: {
        horarioInicio: '00:00',
        duracao: '12:00',
      },
      turnosPrev: [],
      turnosProx: [],
      turnoAtual: null,
      loading: true,
      errorTurno: null,
    }
  },
  watch: {
    form: {
      handler: 'onChange',
      deep: true,
    },
  },
  beforeMount() {
    if (this.data) {
      this.form.horarioInicio = this.data.horarioInicio || '00:00'
      this.form.duracao = this.data.duracao || '12:00'
    }
  },
  mounted() {
    this.$emit('change', { ...this.form })

    if (!this.onlyForm) {
      this.loadTurnos()
    }
  },
  methods: {
    formatDate(date) {
      return formatDate(date, 'DD/MM à\\s HH:mm:')
    },
    onChange() {
      this.$v.form.$touch()

      if (this.$v.form.$invalid) {
        this.$emit('change', null)
        return
      }

      this.$emit('change', { ...this.form })
    },
    loadTurnos() {
      this.errorTurno = null
      this.loading = true

      http
        .get(
          'sensor/virtual/turnos',
          {
            duracao:
              this.form.duracao === '24:00' ? '1.00:00' : this.form.duracao,
            horarioInicio: this.form.horarioInicio,
            localId: this.localId,
          },
          false
        )
        .then((response) => {
          this.turnosPrev = response.antigos
          this.turnosProx = response.proximos
          this.turnoAtual = response.turnoAtual
        })
        .catch(() => {
          this.errorTurno = 'Erro ao calcular turnos.'
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div
        :class="{
          'col-12': onlyForm,
          'col-5': !onlyForm,
        }"
      >
        <md-field :class="getValidationClass('horarioInicio')">
          <label for="horarioInicio">Início</label>
          <md-input
            id="horarioInicio"
            v-model="form.horarioInicio"
            v-mask="'##:##'"
            name="horarioInicio"
            @input="onChange"
          />
          <span v-if="!$v.form.horarioInicio.dayTime" class="md-error"
            >Horário inválido</span
          >
        </md-field>

        <DurationInput
          v-model="form.duracao"
          title="Duração"
          :validation-class="getValidationClass('duracao')"
        >
          <span v-if="!$v.form.duracao.required" class="md-error"
            >Horário inválido</span
          >
        </DurationInput>
      </div>
      <div v-if="!onlyForm" class="col-1">
        <md-button class="md-primary md-raised" @click="loadTurnos">
          <md-tooltip md-direction="top"> Calcular turnos </md-tooltip>
          <md-icon>autorenew</md-icon>
        </md-button>
      </div>
      <div v-if="!onlyForm" class="col-6">
        <div v-if="errorTurno" class="md-error">
          {{ errorTurno }}
        </div>
        <div v-if="!loading && !errorTurno">
          <div class="row">
            <div class="col-4">
              <p class="md-subheading">
                <md-icon>today</md-icon>
                Antigos
              </p>
              <p v-for="t in turnosPrev" :key="t.inicio">
                {{ formatDate(t.inicio) }}
                <md-icon>arrow_right_alt</md-icon>
                {{ formatDate(t.fim) }}
              </p>
            </div>
            <div class="col-4">
              <p class="md-subheading">
                <md-icon>today</md-icon>
                Turno Atual
              </p>
              <p>
                {{ formatDate(turnoAtual.inicio) }}
                <md-icon>arrow_right_alt</md-icon>
                {{ formatDate(turnoAtual.fim) }}
              </p>
            </div>
            <div class="col-4">
              <p class="md-subheading">
                <md-icon>today</md-icon>
                Próximos
              </p>
              <p v-for="t in turnosProx" :key="t.inicio">
                {{ formatDate(t.inicio) }}
                <md-icon>arrow_right_alt</md-icon>
                {{ formatDate(t.fim) }}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <loading :loading="loading" center />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
